import httpClient from "../../utilities/http-client";
import { EFidelityLevelMan, EFidelityLevelWoman, FidelityLevel, Gender } from "../auth/models";

export const getFidelityLevel = async (): Promise<FidelityLevel> => {
	try {
		const { data } = await httpClient.get<FidelityLevel>(`/users/fidelity-level`);
		return data;
	} catch (e:any) {
        console.error("Errore nella richiesta del fidelity level", e);
		return {
			gender: Gender.male,
			level: EFidelityLevelMan.PIONEER
		};
	}
};